/*jshint multistr: true */

/************************************************************************************************************
 * VPSmartMovie v0.9.0
 * Author: Benny Menzel, mackoy consulting, bmenzel@mackoy.de
 * Markup: <div id="containerId"></div><div id="controlsContainerId">[...]</div>
 * Usage: new VPSmartMovie("containerId", 'controlsContainerId', 'qualityNameAsDefinedInJson', true, "/storyboards/definition1.json");
 * Definition: A definition is loaded from JSON
 * Instance-Properties:
 * 		- containerId: main-storyboard-container html-id
 * 		- definition: the storyboard definition (clips, chapters, timings, videos)
 * 		- width: width of the video
 * 		- height: height of the video
 * 		- player: the jwPlayer instance used to display the main movie
 *		- skin: (optional) the name of a skin; The jwPlayer-Skin-CSS must be included into the page header; 'no-fullscreen' is already available by including the storyboard.css-file
 * 		- l10n: (optional) an object containing translations for the controls:
 *				{ controls:{backToMain: "Back to main movie", skipIntermediate: "skip", replay: "replay", selectChapter: "Please select a chapter"} }
 ************************************************************************************************************/
/**
TODO:
-----
- ?  Rename default 'Please select Chapter' and within the smart movie definitions?



CHANGELOG:
----------
v0.9.0 (2017-01-20)
- moved VPSmartMovie into Celemony Tools Webpack v0.0.1; from now on you will find the changes in the general changelog

v0.8.3 (2016-09-29)
- updated jwPlayer to version 7.6.1
- Skins are now referenced by name (not by url); You must include the skin-css by yourself (NOTE that 'no-fullscreen'-skin is already available via storyboard.css)
- some Fixes (clip is now paused when iframe is opened, when clip was playing and you selected a main-chapter the back-to-main-button is now removed correctly)
- NOTE: ga.js is not supported any more! To send events to google analytics, you must load the newer analytics.js

v0.8.2
- When low quality is active (e.g. width < 1000), we permanently display the chapter selector to the left of the video; HD-Versions stay the same

v0.8.1
- added 'ga'-configuration-Object to jwPlayer-Config to push events to GoogleAnalytics (if ga.js has been loaded)

v0.8.0
- Tested with jQuery 2.0.3
- FIX: When you click the 'continue'-button to jump to the next main chapter and you click 'repeat' right after, the wrong anchor is selected (as currentPlayTime is not updated and contains the value from the previous video)

**/

(function(){
  'use strict';
  require('../styles/VideoPlayer/smart-movie.less');

  var $ = require("jquery");
  var jQuery = require("jquery");
  var logger = new (require('../helpers/logger.js'))("VPSmartMovie").setColor("#0bf4a0");
  var helper = require('../helpers/generic.js');
  var VideoPlayer = require('./videoplayer.js');

  module.exports = VPSmartMovie;

  VPSmartMovie.ID_STORYBOARD = "storyboard";
  VPSmartMovie.ID_MOVIE_PLAYER = "sb-ply1";
  VPSmartMovie.ID_CLIP_PLAYER = "sb-ply2";
  VPSmartMovie.ID_SELECTOR = "sb-sel";
  VPSmartMovie.ID_OVERLAY = "storyboard-iframe-overlay";
  VPSmartMovie.CLASS_QUALITIES = "sb-qualities";
  VPSmartMovie.CLASS_CHAPTERS = "sb-chapters";
  VPSmartMovie.CLASS_SKIP_INTERMEDIATE = "sb-skip-intermediate";
  VPSmartMovie.CLASS_BACK_TO_MAIN = "sb-back-to-main";
  VPSmartMovie.CLASS_IMAGE_PRELOADER = "sb-image-preloader";
  VPSmartMovie.CLASS_REPLAY = "sb-replay";
  VPSmartMovie.MS_FADE_INTERMEDIATE = 800;
  VPSmartMovie.MS_FADE_BUTTON = 200;
  VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_IN = 500;
  VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT = 500;

  VPSmartMovie.LINK_TYPE_VIDEO = "video";
  VPSmartMovie.LINK_TYPE_IFRAME = "iframe";

  VPSmartMovie.SEL_QUALITIES = "." + VPSmartMovie.CLASS_QUALITIES;
  VPSmartMovie.SEL_CHAPTERS = "." + VPSmartMovie.CLASS_CHAPTERS;
  VPSmartMovie.SEL_SKIP_INTERMEDIATE = "." + VPSmartMovie.CLASS_SKIP_INTERMEDIATE;
  VPSmartMovie.SEL_BACK_TO_MAIN = "." + VPSmartMovie.CLASS_BACK_TO_MAIN;
  VPSmartMovie.SEL_IMAGE_PRELOADER = "." + VPSmartMovie.CLASS_IMAGE_PRELOADER;
  VPSmartMovie.SEL_REPLAY = "." + VPSmartMovie.CLASS_REPLAY;

  VPSmartMovie.events = {
  	QUALITY_SET: 'VPSmartMovie.QualitySet'	// issued every time a quality is set (first time on init and every time the user changes quality)
  };

  /*

  Container-Positions x/y
  When positioning containers via Strings (e.g. "position":"BR")

  - x/y: horizontal/vertical position
  - startMarginX/startMarginY: Animation 'From'-Value; Will be moved from that value to a margin of 0 or marginY (see below)
  - marginY: a margin from the top or bottom (using minus sign)

  0/0 		 0.5/0 		 		1/0 (TR)
   *--------*--------*
   |								 |
   |	VIDEO-Player	 * 	1/0.5 (MR)
   |								 |
   *--------*--------*
  0/1			 0.5/1				1/1 (BR)

  */

  VPSmartMovie.buttonPosition = {
  	TL: {x:0.0, y:0.0, startMarginX:-1,	startMarginY:0, marginY:0.024}, // top left;
  	TC: {x:0.5, y:0.0, startMarginX:0,	startMarginY:-1}, // top center
  	TR: {x:1.0, y:0.0, startMarginX:1,	startMarginY:0, marginY:0.024}, // top right

  	ML: {x:0.0, y:0.5, startMarginX:-1,	startMarginY:0}, // middle left
  	/*MC: {x:0.5, y:0.5, startMarginX:0, startMarginY:0}, // middle center*/
  	MR: {x:1.0, y:0.5, startMarginX:1,	startMarginY:0},	// middle right

  	BL: {x:0.0, y:1.0, startMarginX:-1,	startMarginY:0, marginY:-0.024}, // bottom left
  	BC: {x:0.5, y:1.0, startMarginX:0,	startMarginY:1}, // bottom center
  	BR: {x:1.0, y:1.0, startMarginX:1,	startMarginY:0, marginY:-0.024}, // bottom right
  };

  var defaults = {
    overlayAutoScale: false,
    l10n:{
      controls:{
        backToMain: "Back to main movie",
        skipIntermediate: "skip",
        replay: "replay",
        selectChapter: "Please select a chapter"
      }
    }
  };

  function VPSmartMovie(mediaInstance, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
    VideoPlayer.call(this, mediaInstance, inline, container, posterMediaImage, defaultQuality, defaults, options, playButtonImage, playButtonHoverImage); // call super constructor.
    logger.debug("initting smartMovie player " + (helper.undefOrNull(options)?"":"with options"), options);
    if (inline){
      throw "You may not instantiate a SmartMovie Inline! SmartMovies may only be opened within an overlay!";
    }
    if (helper.undefOrNull(global.jwplayer)){
      global.jwplayer = {};
    }
  }

  // subclass extends superclass
  VPSmartMovie.prototype = Object.create(VideoPlayer.prototype);
  VPSmartMovie.prototype.constructor = VideoPlayer;

  VPSmartMovie.prototype._play = function _play(container){
    var id = VPSmartMovie.ID_STORYBOARD;

    if ($("#"+id).length>0){
      $('#'+id).remove();
    }
    var $storyboard = $("<div id='"+id+"'></div>");
    var $controls = $("<div id='storyboard-controls'></div>");
    container.append($storyboard);
    container.append($controls);

    var useTwoPlayers = true;
    var skin = "no-fullscreen";
    var quality = !helper.undefOrNull(this.defaultQuality) ? this.defaultQuality : this.media.defaultQualityName();
    logger.debug("Playing Smartmovie");
    this._init($storyboard, $controls, quality, useTwoPlayers, this.media.url(), skin);
  };

  VPSmartMovie.prototype._resize = function _resize(width, height){
    // we do nothing on resize as content is already centered automatically via CMY.Overlay
  };

  // As we override the close method but do not want to copy the method body from
  // 'parent prototype', we just call it from here
  VPSmartMovie.prototype._onClose = function _onClose(){
    this.ready = false;
    if (!helper.undefOrNull(this.players.movie)){
      this.players.movie.stop().remove();
    }
    if (this.players.movie !== this.players.clip){
      this.players.clip.stop().remove();
    }
    logger.debug("JWPlayer(s) destroyed!");
    this.container.css("marginLeft", 0);
    this.container.children().off().empty().remove();
    this.container.off().empty().remove();

    $("#"+VPSmartMovie.ID_STORYBOARD).off().empty().remove();

    logger.debug("DOM Elements destroyed!");
    VideoPlayer.prototype._onClose.call(this);
  };

  VPSmartMovie.prototype._initStoryboard = function _initStoryboard(){
    //add elements
    var elMoviePlayer = $("<div id='"+VPSmartMovie.ID_MOVIE_PLAYER+"'></div>");
    var elClipPlayer = $("<div id='"+VPSmartMovie.ID_CLIP_PLAYER+"'></div>");
    var elSelector = $("<div id='"+VPSmartMovie.ID_SELECTOR+"'></div>");
    var container = this.container;
    container.removeClass();

    container.append(elMoviePlayer);
    if (this.players.twoPlayerMode){
      container.append(elClipPlayer);
    }
    container.append(elSelector);

    // set dimensions and classes according to quality-setting
    container.addClass(this._getQualityCssClass(this.quality));
    var elSetDimension = [container, elMoviePlayer, elClipPlayer, elSelector];
    for (var i=0; i<elSetDimension.length; i++){
      elSetDimension[i].css({ width: this.quality.width, height: this.quality.height});
    }

    // hide selector and buttons at begin
    $('#'+VPSmartMovie.ID_SELECTOR).hide();
  };

  VPSmartMovie.prototype.resize = function resize(width, height){
    throw "Resizing of SmartMovie not supported!";
  };

  VPSmartMovie.prototype._init = function _init(containerOrId, controlsContainerOrId, qualityName, twoPlayerMode, jsonUrl, skin){
    /********************************************************/
  	/*											VARIABLES												*/
  	/********************************************************/
  	this.container = containerOrId instanceof jQuery ? containerOrId : $("#"+containerOrId);
  	this.controls = controlsContainerOrId instanceof jQuery ? controlsContainerOrId : $("#"+controlsContainerOrId);

  	this.skin = skin;
  	this.ready = false;
  	this.players = {
  		current: null,
  		movie: null,
  		clip: null,
  		currentVideoType: "movie", //or clip
  		twoPlayerMode: twoPlayerMode
  	};
  	this.mainMovie = null;
  	this.currentClip = null;
  	this.mainMovieIndex = -1;
  	this.chapters = [];
  	this.configuration = {}; //loaded from json
  	this.quality = null;

    /********************************************************/
    /*											INITIALIZE											*/
    /********************************************************/

    // load definition
    var self = this;
    $.getJSON(jsonUrl, function(data){
      var conf = data.configuration;
      self.configuration = conf;
      self.definition = data.clips;

      // if l10n was not set as parameter of the storyboard and the configuration contains an l10n part - then take it!
      if (typeof conf.l10n !== "undefined" && conf.l10n !== null){
        logger.debug("JSON contains L10N; using it");
        self.l10n = conf.l10n;
      }

      var qual = self._getQuality(qualityName);
      self._initWithQuality( qual );
      self._playMainMovie(0, self.definition[0]);

      self.ready = true;
      logger.debug("smartMovie definition loaded from '"+jsonUrl+"'!");
    }).fail(function(jqXHR, textStatus, errorThrown){
      self.overlay.remove();
      throw "Error loading VPSmartMovie definition from " + jsonUrl + ": " + textStatus + " / " + errorThrown;
    });

  };

  VPSmartMovie.prototype._initWithQuality = function _initWithQuality(qualityDef){
    this.quality = qualityDef;
    this.chapters = this._getChapters(this.definition);

    // init VPSmartMovie
    if (typeof this.players.movie != "undefined" && this.players.movie !== null){
      this.players.movie.stop();
      this.players.movie.remove();
      logger.debug("removed movie player");
    }
    if (typeof this.players.clip != "undefined" && this.players.clip !== null){
      this.players.movie.stop();
      this.players.clip.remove();
      logger.debug("removed clip player");
    }
    this.container.css('minHeight', qualityDef.height);
    this.container.children().off().remove();
    this._initStoryboard();

    // init players
    this._initJwPlayers(this.definition);

    // init controls
    this.controls.children().off().remove();
    this._initControls(this.controls, this.container, this.configuration.qualities, qualityDef, this.chapters, this._getL10n(this.l10n));

    // trigger 'VPSmartMovie.QualitySet'-Event
    $(this.container).trigger(VPSmartMovie.events.QUALITY_SET, [qualityDef]);
  };

  VPSmartMovie.prototype._getQuality = function _getQuality(name){
		var qual = null;
		for (var q=0; q<this.configuration.qualities.length; q++){
			if (this.configuration.qualities[q].name==name){
				qual = this.configuration.qualities[q];
				break;
			}
		}
		if (qual===null){
			logger.error("Quality '"+name+"' is not defined within JSON-File; Please either change JSON or HTML-Template!");
		}
		return qual;
	};


  VPSmartMovie.prototype._getChapters = function _getChapters(mainDef){
    // chapter: clip, clipIndex, start, title
  	var chapters = [];
    var chapter;
    var self = this;
  	for (var i=0; i<mainDef.length; i++){
  		if (typeof mainDef[i].chapters === "undefined" || mainDef[i].chapters === null || mainDef[i].chapters.length < 1){
  			chapter = {};
  			chapter.clip = self._getClipUrl(mainDef[i]);
  			chapter.clipIndex = i;
  			chapter.start = 0;
  			chapter.title = null;
  			chapter.isMainChapter = true;
  			chapters.push(chapter);
  		} else {
  			for (var c=0; c<mainDef[i].chapters.length; c++){
  				chapter = {};
  				chapter.clip = self._getClipUrl(mainDef[i]);
  				chapter.clipIndex = i;
  				chapter.start = mainDef[i].chapters[c].start;
  				if (typeof mainDef[i].chapters[c].title !== "undefined"){
  					chapter.title = mainDef[i].chapters[c].title;
  				} else {
  					chapter.title = null;
  				}
  				chapter.isMainChapter = true;
  				chapters.push(chapter);
  			}
  		}

  		//TODO: CHECK: Currently we add all sub-chapters after the main-chapters; no matter if the intermediate comes in between or before those chapters; is that ok?
  		var subChapters = getSubChapters(mainDef[i], i);
  		for (var ch=0; ch<subChapters.length; ch++){
  			chapters.push(subChapters[ch]);
  		}
  	}
  	return chapters;


  	function getSubChapters(singleDef, mainClipIndex){
  		var subChapters = [];
  		var intermediates = singleDef.intermediates;
  		var sortByStart = function(a, b) {
  		  return (a.start) - (b.start);
  		};
  		intermediates.sort(sortByStart);
  		// Walk structure: singleDef > intermediates > containers > elements > chapterTitle
  		for (var i=0; i<intermediates.length; i++){
  			var containers = intermediates[i].containers;
  			containers.sort(sortByStart);
  			for (var c=0; c<containers.length; c++){
  				var elements = containers[c].elements;
  				elements.sort(function(a, b) {
  						return (a.showTime) - (b.showTime);
  				});
  				for (var l=0;l<elements.length;l++){
  					var displayChapter = !elements[l].hideChapter;
  					if (displayChapter){
  						var chapter = {};
  						chapter.clip = elements[l].type==VPSmartMovie.LINK_TYPE_VIDEO? self._getClipUrl(elements[l]) : self._getIframeUrl(elements[l].url);
  						chapter.clipIndex = mainClipIndex;
  						chapter.start = 0;

  						chapter.title = "";
  						if (typeof elements[l].chapterTitle !== "undefined" && elements[l].chapterTitle!==null && elements[l].chapterTitle.length){
  							chapter.title += elements[l].chapterTitle;
  						} else if (typeof elements[l].button.title !== "undefined" && elements[l].button.title !== null && elements[l].button.title.length){
  							chapter.title += elements[l].button.title;
  						}

  						chapter.isMainChapter = false;
  						chapter.linkDef = elements[l];
  						chapter.mainDef = singleDef;
  						chapter.intermediateDef = intermediates[i];
  						subChapters.push(chapter);
  					}
  				}
  			}
  		}
  		return subChapters;
  	}
  };

  VPSmartMovie.prototype._initJwPlayers = function _initJwPlayers(def){
    var self = this;

    // init JWPlayer(s) and play main-movie
    self.players.movie = jwplayer(VPSmartMovie.ID_MOVIE_PLAYER);
    if (self.players.twoPlayerMode){
      self.players.clip = jwplayer(VPSmartMovie.ID_CLIP_PLAYER);
    } else {
      self.players.clip = self.players.movie;
    }
    self.players.current = self.players.movie;
    //self._playMainMovie(0, def[0]);

    var elStoryboard = $('#'+VPSmartMovie.ID_SELECTOR);
    elStoryboard.click(function(e){
      //only pause/continue playback if the user clicked on the storyboard (not if clicked on a storyboard-child, which could define their own click-events)
      if($(e.target).is(elStoryboard)){
        pause(self);
      }
    });
    function pause(self){
      if (self.players.currentVideoType == "movie"){
        self.players.movie.pause();
      } else {
        self.players.clip.pause();
      }
    }

    this.mainMovieIndex = 0;
  };

  VPSmartMovie.prototype._switchQuality = function _switchQuality(quality){
    /*
    var changeLocation = false;

    if (changeLocation){
      var currentUrl = window.location.href;
      var currentQualityName = this.quality.name.toLowerCase();
      var newUrl = currentUrl.replace(currentQualityName, quality.name.toLowerCase());
      window.location.href = newUrl; // e.g. index234_en_hd.html -> index234_en_sd.html NOTE: WATCH_OUT!: index_sdcard_qual_sd.html would change to index_hdcard_qual_sd.html
    } else {
    */
    var currentPosition = this.players.current.getPosition();
    var currentClipDef = this.currentClip ? this.currentClip.def : null;
    var currentMovieIndex = this.mainMovieIndex ? this.mainMovieIndex : 0;
    var curDef = this.definition[currentMovieIndex];

    // reset mainMovie and clip values
    if (this.currentClip){
      this.currentClip.def = null;
    }
    this.mainMovieIndex = 0;

    this._initWithQuality(quality);
    for (var i=0; i<curDef.intermediates.length; i++){
      this._cleanupIntermediate(curDef.intermediates[i]);
    }

    if (currentClipDef !== null){
      this._playMainMovie(0, curDef, true);
      var onPlayEvent = true;
      this.players.movie.on('ready', function(){
        this.players.movie.on('play', function(){
          if (onPlayEvent){
            onPlayEvent = false;
            this.players.movie.off('ready');
            this.players.movie.off('play');
            var mainDef = this._getMainDef(currentClipDef);
            if (!mainDef){
              mainDef = curDef;
            }
            this._playClip(currentPosition, currentClipDef, null, mainDef);
          }
        });
      });
    } else {
      this._playMainMovie(currentMovieIndex, curDef, true);
      this._returnToMainMovie(currentPosition, curDef);
    }
  //}
  };

  VPSmartMovie.prototype._initControls = function _initControls(controls, storyboardContainer, qualities, quality, chapters, l10n){
    controls.removeClass();
    controls.append( this._getControlsHtml(qualities, l10n) );
    controls.addClass( this._getQualityCssClass(quality) );
    controls.find(VPSmartMovie.SEL_BACK_TO_MAIN).hide();
    controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE).hide();
    controls.css("width", this.quality.width);
    initQualitySelector(this.quality, qualities);
    var self = this;

    $( window ).resize(function() {
      updateChapterDisplay(controls, storyboardContainer, chapters, self.quality, true, self);
    });

    updateChapterDisplay(controls, storyboardContainer, chapters, this.quality, false, self);
    initReplay(controls, self);

    function initQualitySelector(currentQuality, qualities){
      var elQualities = controls.find(VPSmartMovie.SEL_QUALITIES);
      var qualityClassPrefix = "sb-quality-";
      var qualityClass = qualityClassPrefix + currentQuality.name.toLowerCase();
      elQualities.addClass(qualityClass);
      elQualities.click(function(){
        elQualities.removeClass(qualityClass);
        var currentQualityName = currentQuality.name;
        elQualities.removeClass(qualityClassPrefix + currentQualityName.toLowerCase());
        var newQualityName = null;
        if (currentQualityName == "HD"){
          newQualityName = "SD";
        } else {
          newQualityName = "HD";
        }
        elQualities.addClass(qualityClassPrefix + newQualityName.toLowerCase());

        var qualityDef = self._getQuality(newQualityName);
        self._switchQuality(qualityDef);
      });

    }

    function updateChapterDisplay(controls, storyboardContainer, chapters, quality, triggeredByResizeEvent, self){
      var elChapters = storyboardContainer.parent().find(VPSmartMovie.SEL_CHAPTERS);
      var showChaptersOnTheLeft = true;
      var leftChapterSelectorWidth = 256;

      // We want to display the chapter selector either on the left or at the bottom
      // this is decided via the available viewport
      var extraWidth = 60; // width that is added for checking the needed width (e.g. for close button)
      var availWidth = $( window ).width();
      var fullWidth = quality.width + leftChapterSelectorWidth;
      if (availWidth < (fullWidth + extraWidth)){
        showChaptersOnTheLeft = false;
      }

      var chapterObj;
      if (showChaptersOnTheLeft){
        self.chaptersLeft = true;
        chapterObj = initBottomChapterSelector(false);
        chapterObj.open().done(function(){
          modifyBottomToLeftChapterSelector(chapterObj, leftChapterSelectorWidth).done(function(){
          });
          self.overlay.resizeContent(fullWidth, self.overlay.height());
          self.overlay.centerContent();
        });
      } else {
        self.chaptersLeft = false;
        chapterObj = initBottomChapterSelector(true);
        chapterObj.close().done(function(){
        });
        self.overlay.resizeContent(quality.width, self.overlay.height());
        self.overlay.centerContent();
      }


      function modifyBottomToLeftChapterSelector(chapterObj, listWidth){
        elChapters.addClass("left-side");
        var listMargin = {
            marginLeft: listWidth + "px"
        };

        var clone = controls.clone(); //we need a clone here as the original element may currently animate the height and return the wrong value
        elChapters.append(clone); //additionally we need to add it temporarily for safari browser to get the correct height (is 0 otherwise)
        var controlBarHeight = clone.height();
        clone.remove(); //remove the clone after measuring height
        var elChapterHeight = quality.height + controlBarHeight;

        storyboardContainer.css(listMargin);
        controls.css(listMargin);
        elChapters.css({
          left: 0,
          width: listWidth + "px",
          height: elChapterHeight + "px"
        });
        return $.when( elChapters.promise('fx'), controls.promise('fx'), storyboardContainer.promise('fx') );
      }

      function initBottomChapterSelector(allowToggling){
        elChapters.removeClass("left-side");
        storyboardContainer.css("marginLeft", "inherit");
        controls.css("marginLeft", "inherit");
        elChapters.css({
          left: "inherit",
          maxWidth: "inherit"
        });

        var clsSingleChapter = "sb-chapter";
        if (elChapters.children("."+clsSingleChapter).length <= 0){
          _prepareChapters(clsSingleChapter);
        }
        _setSelectMessage(elChapters.data('selectMessage'));
        _setChapterToggling(allowToggling);
        _setChapterSelection();

        function _prepareChapters(clsSingleChapter){
          var toggle = elChapters.children(".sb-toggle-button");
          //elChapters.children("."+clsSingleChapter).remove(); // remove previous chapters if the list was re-initted
          for (var c=0; c<chapters.length; c++){
            var title = chapters[c].title;
            var isMain = chapters[c].isMainChapter;
            var cls = isMain ? 'main' : 'sub';
            //var chapterName = title!=null ? ((c+1)+": "+title) : (c+1);
            var chapterName = title!==null ? (title) : "";
            var option = $("<div class='"+clsSingleChapter+" "+cls+"' data-value='"+c+"'>"+chapterName+"</div>");

            option.insertBefore(toggle);
          }
        }
        function _setChapterSelection(){
          elChapters.children().click(function(){
            //only change chapter, if elChapters is '.open'
            var elChapter = $(this);
            if (!elChapter.hasClass("selected") && !elChapter.hasClass("sb-toggle-button")){
              var chapterIdx = elChapter.data("value");
              var chapter = chapters[chapterIdx];
              elChapters.children().removeClass("selected");
              elChapter.addClass("selected");
              if (chapter.isMainChapter){
                self._returnToMainMovie(chapter.start, self.definition[chapter.clipIndex]);
              } else {
                self._openOrPlayElement(chapter.linkDef, chapter.intermediateDef, chapter.mainDef);
              }
            }
          });
        }
        function _setChapterToggling(allowToggling){
          elChapters.parent().unbind("click"); //unbind previous click events
          if (allowToggling){
            elChapters.parent().removeClass("toggling-disabled");
            elChapters.parent().click(function(evt){ //when clicking the elChapters-container, we toggle the 'open' class; styled via css!
              if (elChapters.hasClass("open")){
                closeList();
                if (typeof evt != "undefined" && evt !== null){
                  evt.stopPropagation(); // stop propagation of the click event
                }
              } else if (elChapters.hasClass("closed") || !elChapters.hasClass("open")) {
                showList();
              }
            });
          } else {
            elChapters.parent().addClass("toggling-disabled");
            elChapters.parent().children(".current").remove();
          }
        }
        function _setSelectMessage(txt){
          var cls = "sb-select-chapter-message";
          if ($("."+cls).length <= 0){
            var elSelectMessage = $("<div></div>")
              //.addClass(VPSmartMovie.CLASS_CHAPTERS)
              //.addClass("current")
              .addClass(cls)
              .text(txt);
            elChapters.parent().prepend(elSelectMessage);
          }
        }
        function closeList(){
          elChapters.parent().removeClass("open");
          elChapters.parent().addClass("closed");
          elChapters.removeClass("open");
          elChapters.addClass("closed");
          elChapters.parent().removeAttr("style");
          elChapters.removeAttr("style");
          self._checkChapterSelectorDimensions();
          return elChapters.promise('fx');
        }
        function showList(){
          elChapters.parent().removeClass("closed");
          elChapters.parent().addClass("open");
          elChapters.removeClass("closed");
          elChapters.addClass("open");

          var posTop = storyboardContainer.position().top;
          var height = storyboardContainer.height();
          var width = elChapters.parent().innerWidth();
          elChapters.css({
            top: posTop,
            height: height,
            width: width,
            position: 'absolute'
          });
          elChapters.parent().css("position", "inherit");
          return elChapters.promise('fx');
        }

        return {
          open: showList,
          close: closeList
        };
      }
    }

    function initReplay(controls, self){
      var elReplay = controls.find(VPSmartMovie.SEL_REPLAY);
      elReplay.click(function(){
        var targetSeconds;
        if (self.players.currentVideoType == 'clip'){
          targetSeconds = self._getCurrentAnchorTime(self.currentClip.def);
          self._playClip(targetSeconds, self.currentClip.def, null, self.mainMovie.def);
        } else {
          targetSeconds = self._getCurrentAnchorTime(self.mainMovie.def);
          self._playMainMovie(targetSeconds, self.mainMovie.def);
        }
      });
    }

  }; /* END function initControls() */

  VPSmartMovie.prototype._playMainMovie = function _playMainMovie(targetSeconds, singleDef, reInitialize){
    function prepareForMovie(self){
      //Clean-up left-over Buttons, etc.
      self._cleanupIntermediates();
      self.players.clip.pause(true);
      if (self.players.twoPlayerMode){
        $("#"+VPSmartMovie.ID_CLIP_PLAYER).hide();
        $("#"+VPSmartMovie.ID_MOVIE_PLAYER).show();
      }
      self.currentClip = null;
      self.players.current = self.players.movie;
      self.players.currentVideoType = 'movie';
      self._preloadImages(singleDef, self.quality.name, self.container);
    }

    // if the main movie finishes playing within a second start the next movie right away
    var currentDuration = this.players.movie.getDuration();
    var alreadyPlayed = currentDuration > 0; // if movie already has been played
    var onlySecondLeft = targetSeconds >= (currentDuration-1);
    prepareForMovie(this);
    var self = this;
    if (alreadyPlayed && onlySecondLeft){
      this._onMainClipComplete();
    } else {
      // If mainMovie is not initialized or some other definition currently plays or if a clip is running we load the movie-file
      // if not, we just jump to the given targetSeconds
      var clipIsRunning = this.players.currentVideoType === 'clip';
      var wasInitialized = false;
      if (reInitialize || this.mainMovie === null || this.mainMovie.def != singleDef || (!this.players.twoPlayerMode && clipIsRunning)){
        this.players.movie = this.players.movie.setup( this._getJwPlayerConfig( this._getClipUrl(singleDef), true) );
        this.players.movie.on('time', function(timeEvent){
          self._checkMainTimeEvent(timeEvent.position, singleDef);
        });
        this.players.movie.on('complete', function(){
          self._onMainClipComplete();
        });

        //logger.debug("Setting mainMovie.def to", this.mainMovie);
        this.mainMovie = {};
        this.mainMovie.def = singleDef;
        for (var i=0; i<this.definition.length; i++){
          if (this.definition[i]==singleDef){
            this.mainMovieIndex = i;
            break;
          }
        }
        wasInitialized=true;
      }

      // replace current jwPlayer with the movie-player (which could contain some other jwPlayer instance if the above if resolved to true)
      if (this.players.current !== this.players.movie){
        this.players.current = this.players.movie;
      }
      this.mainMovie.targetSeconds = targetSeconds;
      if (!wasInitialized){
        this.players.movie.seek(this.mainMovie.targetSeconds);
      } else {
        this.players.movie.on('ready', function(){
          this.players.movie.seek(this.mainMovie.targetSeconds);
        });
      }
    }

    var fullWidth = this.quality.width;
    if (!self.chaptersLeft){
      self.overlay.resizeContent(fullWidth, self.overlay.height());
      self.overlay.centerContent();
    } else {
      var elChapters = self.controls.parent().find(VPSmartMovie.SEL_CHAPTERS);
      window.setTimeout(function(){
        var outer = elChapters.outerWidth();
        fullWidth = fullWidth + outer;
        self.overlay.resizeContent(fullWidth, self.overlay.height());
        self.overlay.centerContent();
      }, 300); // CSS-Animation is set to 200 seconds; We need to wait for this before getting the width
      //TODO: We could optimize this by transferring the css animation into a jquery-animation; That way we can wait for
      //the elements promise() until we get its css values
    }
  };

	VPSmartMovie.prototype._playClip = function _playClip(targetSeconds, elementDef, intermediate, singleDef){
    var self = this;
		if (this.players.currentVideoType !== 'clip'){
			this._initClipPlayer();
		}
		this.players.currentVideoType = 'clip';
		this._findAndSelectChapter(elementDef);

		if (intermediate !== null){
			this._cleanupIntermediate(intermediate);
		} else {
			this._cleanupIntermediates();
		}
		if (this.currentClip === null){
			this.currentClip = {};
		}
		this.currentClip.targetSeconds = targetSeconds;
		$(document).off('click', VPSmartMovie.SEL_BACK_TO_MAIN);
		$(VPSmartMovie.SEL_BACK_TO_MAIN).show();
		$(document).on('click', VPSmartMovie.SEL_BACK_TO_MAIN, function(e){
			self._returnToMainMovie(elementDef.returnTimeClipCancelled, singleDef);
		});

		if (this.currentClip.def !== elementDef){ //should we play some other clip? then load it!
			this.currentClip.def = elementDef;

			var player = this.players.clip.setup( this._getJwPlayerConfig( this._getClipUrl(elementDef), true) );
			this.players.clip = player;
			this.players.current = player;
			player.on('ready', function(){
				self.players.clip.seek(targetSeconds);

				player.on('complete', function(){
					self._returnToMainMovie(elementDef.returnTimeClipFinished, singleDef);
				});
				player.on('error', function(message){
					logger.error("Clip error: '"+message+"' - should return to main movie");
					returnToMainMovie(elementDef.returnTimeClipCancelled, singleDef);
				});
			});
		} else { // we just want to seek, as the clip is the same clip as before
			self.players.clip.seek(targetSeconds);
		}
	}; /* END function playClip() */

  VPSmartMovie.prototype._initClipPlayer = function _initClipPlayer(){
		//Clean-up left-over Buttons, etc.
		this._cleanupIntermediates();

		this.players.movie.pause(true);
		//logger.debug("paused movie player");
		if (this.players.twoPlayerMode){
			$("#"+VPSmartMovie.ID_MOVIE_PLAYER).hide();
			$("#"+VPSmartMovie.ID_CLIP_PLAYER).show();
		}
		this.players.current = this.players.clip;
		//logger.debug("current player is now clip-player");
	};

	VPSmartMovie.prototype._returnToMainMovie = function _returnToMainMovie(targetSeconds, singleDef){
		//logger.debug("returning to main movie");
		$(VPSmartMovie.SEL_BACK_TO_MAIN).hide();
		this._playMainMovie(targetSeconds, singleDef);
	};


  VPSmartMovie.prototype._cleanupIntermediates = function _cleanupIntermediates(){
    var elStoryboard = $('#'+VPSmartMovie.ID_SELECTOR);
    var fadeOutTime = VPSmartMovie.MS_FADE_INTERMEDIATE;

    elStoryboard.fadeOut(fadeOutTime, function(){
      elStoryboard.empty();
    });

    //re-enable controls like the seeking-bar
    if (typeof this.players.current.getControls() != "undefined"){
      this.players.current.setControls(true);
    }

    // hide skip-intermediate-button
    this.controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE).hide();
  };

  VPSmartMovie.prototype._onMainClipComplete = function _onMainClipComplete(){
    //logger.debug("Finished playing main clip #" + (this.mainMovieIndex+1));
    var def = this.definition;
    var nextMainClip = def[this.mainMovieIndex+1];
    if (typeof nextMainClip !== "undefined" && nextMainClip !== null){
      //logger.debug("starting next main clip #" + (this.mainMovieIndex+2));
      this._playMainMovie(0, def[this.mainMovieIndex+1]);
    } else {
      //logger.debug("no next main clip available; moving to first one and stopping playback");
      this._playMainMovie(0, def[0]);
      this.players.movie.stop();
    }
  };

  /********************************************************/
  /*											URL-METHODS											*/
  /********************************************************/


  VPSmartMovie.prototype._getImageUrl = function _getImageUrl(containerOrElementDef){
    var imageDef = containerOrElementDef;
    var imageUrl = null;
    if (typeof imageDef.image == 'undefined' || imageDef.image===null){
      imageUrl = null;
    } else if (typeof imageDef.image === 'string' || imageDef.image instanceof String){ //old or singleResolution version
      imageUrl = imageDef.image;
    } else { //SD or HD?
      imageUrl = imageDef.image[this.quality.name];
    }
    var url = this._getUrl(imageUrl);
    return url;
  };

  /**
  * Returns an URL for the given URL; Checks if url needs to be transformed and returns the correct url;
  * Method should be used whenever a clip- or image-url is needed/given;
  * If no BaseUrl is set within this.configuration.baseUrl, the Url is ALWAYS returned as is
  * Examples with BaseUrl set to http://example.com/:
  * - http://www.google.de -> http://www.google.de
  * - test/something -> http://example.com/test/something
  * - /test/something -> http://example.com//test/something
  */
  VPSmartMovie.prototype._getUrl = function _getUrl(fullUrlOrPart){
    if (typeof fullUrlOrPart == "undefined" || fullUrlOrPart === null || fullUrlOrPart.length < 1){
      return null;
    }
    var startsWithHttp = fullUrlOrPart.slice(0,4) == "http";
    var completeUrl = fullUrlOrPart;
    if (!startsWithHttp){
      var baseUrl = this.configuration.baseUrl;
      var baseSet = typeof baseUrl != "undefined" && baseUrl !== null && baseUrl.slice(0,4) == "http";
      if (baseSet){
        completeUrl = baseUrl + fullUrlOrPart;
      }
    }
    return completeUrl;
  };


	VPSmartMovie.prototype._getIframeUrl = function _getIframeUrl(url){
		return this._getUrl(url);
	};

  VPSmartMovie.prototype._getClipUrl = function _getClipUrl(mainOrElementDef){
		var clipUrl = null;
		if (typeof mainOrElementDef.clip == 'undefined' || mainOrElementDef.clip===null){
			clipUrl = null;
		} else if (typeof mainOrElementDef.clip === 'string' || mainOrElementDef.clip instanceof String){ //old or singleResolution version
			clipUrl = mainOrElementDef.clip;
		} else { //SD or HD?
			clipUrl = mainOrElementDef.clip[this.quality.name];
		}
		return this._getUrl(clipUrl);
  };

  VPSmartMovie.prototype._updateChapterSelection = function _updateChapterSelection(newIndex){
    var chapterSelector = this.controls.find(VPSmartMovie.SEL_CHAPTERS);
    if (chapterSelector.children(".selected").index() != newIndex && !chapterSelector.is(":focus")){
      //chapterSelector[0].selectedIndex = newIndex;
      chapterSelector.children().removeClass("selected");
      $(chapterSelector.children()[newIndex]).addClass("selected");
      this._checkChapterSelectorDimensions();
    }
  };

  VPSmartMovie.prototype._checkChapterSelectorDimensions = function _checkChapterSelectorDimensions(){
    var chapterSelector = this.controls.find(VPSmartMovie.SEL_CHAPTERS).parent();
    chapterSelector.removeClass("side-by-side");
    chapterSelector.removeClass("above-and-below");

    var childWidth = 0;
    chapterSelector.children().each(function(){
      childWidth += $(this).outerWidth();
    });

    if (chapterSelector.innerWidth() < childWidth){
      chapterSelector.addClass("above-and-below");
    } else {
      chapterSelector.addClass("side-by-side");
    }
  };

	VPSmartMovie.prototype._findAndSelectChapter = function _findAndSelectChapter(linkDef){
		//logger.debug("finding and selecting chapter", linkDef);
		for (var i=0; i<this.chapters.length; i++){
			var chapter = this.chapters[i];
			//logger.debug(chapter.linkDef);
			if (!chapter.isMainChapter && chapter.linkDef==linkDef){
				this._updateChapterSelection(i);
				break;
			}
		}
	};

  VPSmartMovie.prototype._cleanupIntermediate = function _cleanupIntermediate(intermediate){
    this._cleanupIntermediates();

    this.controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE).hide();
    intermediate.active = false;
    $.each(intermediate.containers, function(index, container){
      container.active = false;
      $.each(container.elements, function(ind2, element){
        element.active = false;
      });
    });
  };

  VPSmartMovie.prototype._checkMainTimeEvent = function _checkMainTimeEvent(second, singleDef){
		var elStoryboard = $('#'+VPSmartMovie.ID_SELECTOR);
    var self = this;
		checkIntermediates(second, singleDef.intermediates, self);
		checkChapters(second, self);

		function checkChapters(second, self){
  			//find possible Chapters
  			var possibleChapters = [];
  			for (var c=0; c<self.chapters.length; c++){
  				var chapter = self.chapters[c];
  				if (chapter.isMainChapter && chapter.clipIndex == self.mainMovieIndex){
  					if (chapter.start <= second){
  						possibleChapters.push( {'chapter':chapter, 'idx':c} );
  					}
  				}
  			}

  			//find the current chapter
  			var currentChapterIdx = possibleChapters[0].idx;
  			if (possibleChapters.length>1){
  				var startTime = 0;
  				for (var i=0; i<possibleChapters.length; i++){
  					//get chapter with latest start-time (as it is still before 'second')
  					if (possibleChapters[i].chapter.start >= startTime){
  						startTime = possibleChapters[i].chapter.start;
  						currentChapterIdx = possibleChapters[i].idx;
  					}
  				}
  			}

  			var currentChapter = self.chapters[currentChapterIdx];
  			self.mainMovie.targetSeconds = currentChapter.start;
  			self._updateChapterSelection(currentChapterIdx);
		} /* END function checkChapters() */

		function checkIntermediates(second, intermediates, self){
  			$.each(intermediates, function(index, intermediate){ //TODO: Maye we can optimize this, so that we do not need to iterate on every event
  				if (typeof intermediate.active == "undefined" || !intermediate.active){
  					//logger.debug("having intermediate @ " + intermediate.start);
  					if (second >= intermediate.start && second <= intermediate.end){ //make intermediate active
  						// Exit HTML5-Fullscreen if active
  						self._jwExitFullscreen();

  						elStoryboard.fadeIn(VPSmartMovie.MS_FADE_INTERMEDIATE);
  						intermediate.active = true;

  						//disable controls like the seeking-bar
  						self.players.current.setControls(false);

  						var button = self.controls.find(VPSmartMovie.SEL_SKIP_INTERMEDIATE);
  						button.parent().show();
  						button.show();
  						button.unbind("click"); //unbind previous click-events
  						//logger.debug("Showing Intermediate ("+intermediate.start+"s -> "+intermediate.end+"s) ...");

  						button.click(function(event){
  							self._playMainMovie(intermediate.end, self.mainMovie.def);
  							button.hide();
  						});
  						//TODO: Check: can't we break here?
  					}
  				} else {
  					if (second >= intermediate.end-0.5 || second < intermediate.start){ //hide intermediate
  						self._cleanupIntermediate(intermediate);
  					} else { //intermediate is still active; lets see if there are containers to be shown or hidden
  						checkContainers(second, intermediate, self.quality, elStoryboard);
  					}
  				}
  			}); /* END $each */

        function checkContainers(second, intermediate, qualitySetting, containerTarget){
          function animateIn(containerEl, posType, callback){
            // e.g. animate TL from '-width' to '0'
            containerEl.animate({'marginLeft':0, 'marginTop':0}, VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_IN, function(){
              if (typeof callback !== "undefined" && callback !== null && typeof callback == "function"){
                callback();
              }
            });
          }
          function animateOut(containerEl, posType, callback){
            // e.g. animate TL from '0' to -width
            var left = posType.startMarginX * containerEl.width();
            var top = posType.startMarginY * containerEl.height();
            containerEl.animate({'marginLeft':left, 'marginTop':top}, VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT, function(){
              if (typeof callback !== "undefined" && callback !== null && typeof callback == "function"){
                callback(containerEl);
              }
            });
          }
          function removeAfterAnimation(el){
            el.remove();
          }
          for(var i=0; i<intermediate.containers.length; i++){
            var containerDef = intermediate.containers[i];
            var containerStart = intermediate.start + containerDef.start;
            var containerEnd = intermediate.start + containerDef.end;
            var atStart = second >= (containerStart - (VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT/1000));
            var beforeEnd = second < (containerEnd - (VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT/1000));
            var afterEnd = second > (containerEnd - (VPSmartMovie.MS_ANIMATE_ELEMENT_CONTAINER_OUT/1000));
            var posType;
            if (typeof containerDef.active == "undefined" || !containerDef.active){
              if (atStart && beforeEnd){
                var containerEl = self._createElementContainer(intermediate, i, qualitySetting);
                containerDef.domElement = containerEl;

                // ANIMATE-IN
                posType = VPSmartMovie.buttonPosition[containerDef.position];
                animateIn(containerEl, posType);
                containerTarget.append(containerEl);
                containerDef.active = true;
              }
            } else if (afterEnd){
              containerDef.active = false;
              if (typeof containerDef.domElement!="undefined" && containerDef.domElement !== null){
                // ANIMATE-OUT
                posType = VPSmartMovie.buttonPosition[containerDef.position];
                var el = containerDef.domElement;
                delete containerDef.domElement;
                animateOut(el, posType, removeAfterAnimation);
/*
                animateOut(el, posType, function(){
                  el.remove();
                });
                */
              }
            }
          }
        }/* END function checkContainers */
		} /* END function checkIntermediates */
	}; /* END function checkMainTimeEvent */

	VPSmartMovie.prototype._createElementContainer = function _createElementContainer(intermediateDef, containerIndex, qualitySetting){
		var containerDef = intermediateDef.containers[containerIndex];
		var elContainer = this._getContainerHtml(containerDef, qualitySetting);
    var self = this;
		$.each(containerDef.elements, function(_index, elementDef){
			var elButton = self._getButtonHtml(_index, elementDef, qualitySetting);
			elButton.hide();
			elButton.click(function(){
				self._openOrPlayElement(elementDef, intermediateDef, self.mainMovie.def);
			});
			elButton.hover(function(){
				var imageUrl = self._getImageUrl( elementDef );
				elContainer.css('backgroundImage', "url("+imageUrl+")");
			}, function(){
				var imageUrl = self._getImageUrl( containerDef );
				elContainer.css('backgroundImage', "url("+imageUrl+")");
			});
			elContainer.append(elButton);
			elButton.fadeIn(VPSmartMovie.MS_FADE_BUTTON);
			elementDef.active = true;
		});
		return elContainer;
	};

	VPSmartMovie.prototype._openOrPlayElement = function _openOrPlayElement(elementDef, intermediateDef, singleDef){
		if (elementDef.type==VPSmartMovie.LINK_TYPE_VIDEO){
			this._playClip(0, elementDef, intermediateDef, singleDef);
		} else if (elementDef.type==VPSmartMovie.LINK_TYPE_IFRAME){
			this._showIframe(elementDef, intermediateDef, singleDef);
		} else {
			logger.error("undefined Container-Element-Type");
		}
	};

	/********************************************************/
	/*											JW-SPECIFIC											*/
	/********************************************************/

	VPSmartMovie.prototype._getJwPlayerConfig = function _getJwPlayerConfig(clipUrl, autostart, controls){
		if (typeof(autostart)==='undefined') autostart = true;
		if (typeof(controls)==='undefined') controls = true;
    var jwSetup = {
			file: clipUrl,
			width: this.quality.width,
			height: this.quality.height,
	    provider: 'video',
			controls: controls,
			ga: {},
			autostart: autostart	//NOTE: Does not work on mobile Devices
    };
		if (typeof this.skin !== "undefined" && typeof this.skin !== null){
			jwSetup.skin=this.skin; //NOTE: Altough the Fullscreen-Button is removed, some Browsers still allow going into fullscreen via doublelick; it seems that there is no way to prevent this
		}
		return jwSetup;
	};


	// Exit HTML5-Fullscreen if active
	VPSmartMovie.prototype._jwExitFullscreen = function _jwExitFullscreen(){
		if(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement){
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		}
	};

  /********************************************************/
  /*									HTML GENERATORS											*/
  /********************************************************/

  VPSmartMovie.prototype._showIframe = function _showIFrame(linkDef, intermediate, singleDef){
    this._findAndSelectChapter(linkDef);
    this.players.current.pause(true);
    this._cleanupIntermediate(intermediate);
    var self = this;

    // OVERLAY
    var overlay = $("<div id='"+VPSmartMovie.ID_OVERLAY+"'></div>").css({
      'position':'fixed',
      'z-index':self._getMaxZ()+10,
      'top':'0',
      'left':'0',
      'display':'block',
      'overflow':'hidden'
    });

    // Set overflow:hidden for body, to prevent scrolling invisible content on the Mac while iframe is opened
    // will be reverted, when back-button is clicked
    var overflow = $("body").css('overflow');
    $("body").css('overflow', 'hidden');

    // BACK-BUTTON
    var l10n = self._getL10n(this.l10n);
    var backbutton = $("<a class='btn "+VPSmartMovie.CLASS_BACK_TO_MAIN+"'>"+l10n.controls.backToMain+"</div>");
    backbutton.addClass(VPSmartMovie.CLASS_BACK_TO_MAIN);
    backbutton.click(function(){
      $("body").css('overflow', overflow);
      overlay.remove();
      self._returnToMainMovie(linkDef.returnTime, singleDef);
      self.players.movie.pause(false);
    });
    backbutton.css({
      'backgroundColor':'white',
      'position':'fixed',
      'width':'100%',
      'cursor':'pointer'
    });

    // IFRAME
    var iframe = $("<iframe src='"+linkDef.url+"' width='100%' height='100%'></iframe>");

    updateOverlaySizes();
    iframe.on('load', updateOverlaySizes);
    $(window).resize(updateOverlaySizes);

    overlay.append( backbutton );
    overlay.append( iframe );
    $("body").prepend(overlay);

    function updateOverlaySizes(){
      var h = $(window).height();
      var w = $(window).width();
      overlay.height(h);
      overlay.width(w);
      overlay.children("iframe").attr('height', h+'px').attr('width', w);
    }
  };

  VPSmartMovie.prototype._getControlsHtml = function _getControlsHtml(qualities, l10n){
    l10n = this._getL10n(l10n);
    /*
    var qualitiesHtml = "";
    for (var i=0; i<qualities.length;i++){
      var quality = qualities[i];
      qualitiesHtml += '<div class="sb-quality" data-index="'+i+'">'+quality.name+'<div>';
    }
    */
    var qualitiesHtml = '';
    var html = ' \
      <div class="sb-control sb-button sb-left"> \
        <div class="'+VPSmartMovie.CLASS_BACK_TO_MAIN+'">'+l10n.controls.backToMain+'</div> \
        <div class="'+VPSmartMovie.CLASS_SKIP_INTERMEDIATE+'">'+l10n.controls.skipIntermediate+'</div> \
      </div> \
      <div class="sb-control sb-button sb-right"> \
        <div class="'+VPSmartMovie.CLASS_REPLAY+'">'+l10n.controls.replay+'</div> \
      </div> \
      <div class="sb-control sb-button sb-right" style="max-width: 10%"> \
        <div class="'+VPSmartMovie.CLASS_QUALITIES+'"> \
        '+qualitiesHtml+' \
        </div> \
      </div> \
      <div class="sb-control sb-select sb-right"> \
        <div class="'+VPSmartMovie.CLASS_CHAPTERS+'" data-select-message="'+l10n.controls.selectChapter+'"><div class="sb-toggle-button"></div></div> \
      </div> \
      ';
    return html;
  };

  VPSmartMovie.prototype._getContainerHtml = function _getContainerHtml(containerDef, qualitySetting){
    var el = $("<div class='sb-container'></a>");
    // position may be defined via a value from VPSmartMovie.buttonPosition
    var self = this;
    var width = containerDef.width * qualitySetting.ratio;
    var height = containerDef.height * qualitySetting.ratio;
    var fullWidth = qualitySetting.width;
    var fullHeight = qualitySetting.height;
    var pos = VPSmartMovie.buttonPosition[containerDef.position];
    var moveLeft = width * pos.x;  // if pos.x is 1 the element should be displayed on the right and as the position-anchor is on the top left, we need to move the button to the left by it's full width
    var moveUp = height * pos.y; // same here; if element should be placed at bottom (pos.y=1) we need to substract the elements height as it's anchor is on the top left
    var startMarginLeft = pos.startMarginX * width;
    var startMarginTop = pos.startMarginY * height;
    var marginY = (typeof pos.marginY != "undefined" && pos.marginY !== null)? Math.round(fullWidth * pos.marginY) : 0;
    var marginX = (typeof pos.marginX != "undefined" && pos.marginX !== null)? Math.round(fullWidth * pos.marginX) : 0;
    var xPos = fullWidth*pos.x - moveLeft + marginX;
    var yPos = fullHeight*pos.y - moveUp + marginY;

    el.css({
      "position":"absolute",
      "left":xPos,
      "top":yPos,
      "width":width,
      "height":height,
      "marginLeft":startMarginLeft,
      "marginTop":startMarginTop,
      "backgroundImage": "url("+self._getImageUrl(containerDef)+")"
    });

    return el;
  };

  VPSmartMovie.prototype._getButtonHtml = function _getButtonHtml(index, containerElementDef, qualitySetting){
    var ratio = qualitySetting.ratio;
    var buttonDef = containerElementDef.button;
    var width = buttonDef.width * ratio;
    var height = buttonDef.height * ratio;
    var xPos = buttonDef.x * ratio;
    var yPos = buttonDef.y * ratio;

    //prepare outer link Element
    var linkEl = $("<a class='sb-button'></a>");
    linkEl.css({
      "position":"absolute",
      "left":xPos,
      "top":yPos,
      "width":width,
      "height":height
    });
    linkEl.data('clip', this._getClipUrl(containerElementDef));
    linkEl.data('index', index);

    //return link-element
    return linkEl;
  };


  /********************************************************/
  /*										HELPERS, ETC											*/
  /********************************************************/

  VPSmartMovie.prototype._getCurrentAnchorTime = function _getCurrentAnchorTime(movieOrClipDef){
    function getCurrentStart(anchorOrChapter, currentPlayTime){
      var currentStart = 0;
      var candidates = [];
      for (var i=0; i<anchorOrChapter.length; i++){
        var anchor = anchorOrChapter[i];
        if (anchor.start<=currentPlayTime){
          candidates.push(anchor.start);
        }
      }
      if (candidates.length>0){
        currentStart = Math.max.apply(Math, candidates);
      }
      return currentStart;
    }

    var anchorTime = 0;
    //Try anchors first
    if (typeof movieOrClipDef.anchors !== "undefined" && movieOrClipDef.anchors !== null && movieOrClipDef.anchors.length>0){
      anchorTime = getCurrentStart(movieOrClipDef.anchors, this.players.current.getPosition());
      //logger.debug("anchorTime", anchorTime);
    }
    /*
    //if no anchors, try chapters
    else if (typeof movieOrClipDef.chapters !== "undefined" && movieOrClipDef.chapters != null && movieOrClipDef.chapters.length>0){
      anchorTime = getCurrentStart(movieOrClipDef.chapters, current);
    }
    */
    //logger.debug("currentAnchorTime is " + anchorTime + " after "+ current +" seconds of the video have been played");
    return anchorTime;
  };

  VPSmartMovie.prototype._getQualityCssClass = function _getQualityCssClass(quality){
    var classname="large";
    if (this._isLowWidthQuality(quality)){
      classname="small";
    }
    return classname;
  };

  VPSmartMovie.prototype._isLowWidthQuality = function _isLowWidthQuality(quality){
    return quality.width < 1000;
  };

  // return the documents max z-index
  VPSmartMovie.prototype._getMaxZ = function _getMaxZ(){
    return Math.max.apply(null,$.map(jQuery('body > *'), function(e,n){
      if(jQuery(e).css('position')=='absolute' || jQuery(e).css('position')=='static' || jQuery(e).css('position')=='fixed'){
        var zIndex = jQuery(e).css('z-index');
        return parseInt(zIndex) || 1 ;
      }
    }));
  };

  //check if the given l10n is undefined or null and return a default l10n in that case
  VPSmartMovie.prototype._getL10n = function _getL10n(l10n){
    if (typeof l10n=="undefined" || l10n===null){
      l10n = this.options.l10n;
    }
    return l10n;
  };

  VPSmartMovie.prototype._getMainDef = function _getMainDef(clipDef){
    var def = null;
    for (var d=0; d<this.definition.length; d++){
      var someDef = this.definition[d];
      for (var i=0; i<someDef.intermediates.length; i++){
        var intermediate = someDef.intermediates[i];
        for (var c=0; c<intermediate.containers.length; c++){
          var container = intermediate.containers[c];
          for (var e=0; e<container.elements.length; e++){
            var element = container.elements[e];
            if (element == clipDef){
              def = someDef;
              break;
            }
          }
        }
      }
    }
    return def;
  };

  VPSmartMovie.prototype._preloadImages = function _preloadImages(singleDef, qualityName, targetContainer){
    function preload(url, target){
      var imageDiv = jQuery("<img src='"+url+"' />");
      var css = {
        'backgroundImage': 'url('+url+')',
        'display': 'block'
      };
      imageDiv.css(css);
      target.append(imageDiv);
    }
    try {
      var imageUrls = [];
      var intermediates = singleDef.intermediates;
      var target = targetContainer.children(VPSmartMovie.SEL_IMAGE_PRELOADER);
      if (!target.length){
        target = jQuery("<div class='"+VPSmartMovie.CLASS_IMAGE_PRELOADER+"'></div>");
        var css = {
            'visibility':'hidden',
            'overflow':'hidden',
            'width':0,
            'height':0,
            'zIndex':0
        };
        target.css(css);
        targetContainer.append(target);
      }
      for (var i=0; i<intermediates.length; i++){
        var intermediate = intermediates[i];
        for (var c=0; c<intermediate.containers.length; c++){
          var container = intermediate.containers[c];
          var containerImageUrl = this._getImageUrl(container, qualityName);
          imageUrls.push(containerImageUrl);
          for (var e=0; e<container.elements.length; e++){
            var element = container.elements[e];
            var elementImageUrl = this._getImageUrl(element, qualityName);
            imageUrls.push(elementImageUrl);
          }
        }
      }
      for (var u=0; u<imageUrls.length; u++){
        var url = imageUrls[u];
        //logger.debug("Preloading Image " + url);
        preload(url, target);
      }
    }
    catch(err) {
      logger.error("could not preload all images! ", err);
      //IGNORE
    }
  };

  /*
  DEFINITION-EXAMPLE-JSON:
  NOTE: showTime and hideTime are both relative to their parents 'start'
  NOTE: This is an old version (which should still work), please see json-file for further properties
  NOTE: you can set a string for clip and image to use the url for all qualities or define an url for each quality (e.g. clip:{sd:"http...", hd:"http..."}, image:{sd{url:"", hoverUrl:""}})
  NOTE: button-definitions may either contain 'x'- and 'y'-coordinates or a 'position'-String; if 'x' and 'y' are defined they have precedence over 'position'; See VPSmartMovie.buttonPosition for position-strings
  */
}());



//////////////////
// WEBPACK FOOTER
// ./src/VideoPlayer/videoplayer_smartmovie.js
// module id = 30
// module chunks = 0